import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'
import { KeepAlive } from 'vue'

const couponRouter: Array<RouteRecordRaw> = [
    {
        path: '/electron',
        name: '卡券SaaS',
        component: Layout,
        redirect: '/electron/factory-list',
        meta: { title: '卡券SaaS', icon: 'icon-card', alwaysShow: true },
        children: [
            /************* 目前厂家管理未使用，隐藏 ****************/
            // {
            //     path: 'factory-list',
            //     name: '厂家管理',
            //     component: () => import('@/views/electron/FactoryList.vue'),
            //     meta: { title: '厂家管理'}
            // },
            {
                path: 'products-electron-list',
                name: '电子券商品管理',
                component: () => import('@/views/electron/ProductsList.vue'),
                meta: { title: '总商品库管理' }
            },
            {
                path: 'channel-products-list',
                name: '渠道/运营商品管理',
                component: () => import('@/views/electron/ChannelProductsList.vue'),
                meta: { title: '渠道商品管理', keepAlive: true, depth: 30}
            },
            {
                path: 'api-channel-products-list',
                name: 'api渠道商品管理',
                component: () => import('@/views/electron/ApiChannelProductsList.vue'),
                meta: { title: '渠道商品管理'}
            },
            {
                path: 'products-edit',
                name: '电子券商品管理编辑',
                component: () => import('@/views/electron/ProductsEdit.vue'),
                meta: { title: '商品编辑', depth: 40 }
            },
            {
                path: 'channel-products-edit',
                name: '渠道商品配置',
                component: () => import('@/views/electron/ChannelProductsEdit.vue'),
                meta: { title: '渠道商品配置', depth: 40 }
            },
            {
                path: 'products-log-list',
                name: '商品配置记录',
                component: () => import('@/views/electron/ProductLog.vue'),
                meta: { title: '商品配置记录'}
            },
            {
                path: 'channel-log-list',
                name: '渠道配置记录',
                component: () => import('@/views/electron/ChannelLog.vue'),
                meta: { title: '渠道配置记录'}
            },
            // {
            //     path: 'order-list',
            //     name: '订单管理',
            //     component: () => import('@/views/electron/OrderList.vue'),
            //     meta: { title: '订单管理'}
            // },
            // {
            //     path: 'mixed-order-list',
            //     name: '卡券总订单管理',
            //     component: () => import('@/views/electron/MixedOrderList.vue'),
            //     meta: { title: '订单管理(整合)', keepAlive: true}
            // },
            {
                path: 'mixed-order-detail',
                name: '卡券总订单详情',
                component: () => import('@/views/electron/MixedOrderDetail.vue'),
                meta: { title: '订单详情(整合)'}
            },
            {
                path: 'order-detail',
                name: '渠道运营订单详情',
                component: () => import('@/views/electron/OrderDetail.vue'),
                meta: { title: '订单详情'}
            },
            {
                path: 'cancelled-list',
                name: '电子券作废统计',
                component: () => import('@/views/electron/CancelledList.vue'),
                meta: { title: '电子券作废统计'}
            },
            {
                path: 'channel-list',
                name: '卡券SaaS渠道管理',
                component: () => import('@/views/electron/ChannelList.vue'),
                meta: { title: '渠道管理'}
            },
            {
                path: 'limit-list',
                name: '卡券SaaS黑白名单',
                component: () => import('@/views/electron/LimitList.vue'),
                meta: { title: '黑白名单管理'}
            },
            {
                path: 'all-order-list',
                name: '新卡券总订单管理',
                component: () => import('@/views/electron/AllOrderList.vue'),
                meta: { title: '订单管理(平台/卡券)', keepAlive: true}
            },
            {
                path: 'saas-order-list',
                name: '卡券saas订单',
                component: () => import('@/views/electron/SaasOrderList.vue'),
                meta: { title: '卡券saas订单', keepAlive: true}
            },
            {
                path: 'all-order-detail',
                name: '新卡券总订单详情',
                component: () => import('@/views/electron/AllOrderDetail.vue'),
                meta: { title: '订单详情(平台、卡券saas)'}
            },
            {
                path: 'saas-channel-dot',
                name: 'SaaS渠道加点',
                component: () => import('@/views/electron/SaasChannelServiceRate.vue'),
                meta: { title: 'SaaS渠道加点'}
            },
            {
                path: 'saas-channel-log',
                name: '渠道加点记录',
                component: () => import('@/views/electron/SaasChannelServiceRateLog.vue'),
                meta: { title: '渠道加点记录'}
            },
            {
                path: 'brand-list',
                name: '电子券品牌管理',
                component: () => import('@/views/electron/BrandList.vue'),
                meta: { title: '品牌管理'}
            },
            {
                path: 'cats-list',
                name: '分类管理',
                component: () => import('@/views/electron/CatsList.vue'),
                meta: { title: '分类管理'}
            },
            {
                path: 'store-list',
                name: '电子券门店管理',
                component: () => import('@/views/electron/StoreList.vue'),
                meta: { title: '门店管理'}
            },
            {
                path: 'store-edit',
                name: '电子券门店详情',
                component: () => import('@/views/electron/StoreEdit.vue'),
                meta: { title: '门店详情'}
            },
        ]
    }
]

export default couponRouter